import { ProfileImage } from "./styles";

export function ProfileHero() {
    return (
        <ProfileImage/>
    )
}